export default "__VITE_ASSET__CID7wrmD__"